import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';

import { Button, Dropdown } from 'react-bootstrap';

import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Cargoplane from "../../../../assets/images/plane.svg";
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { ULDONAIRGRID, EDITONAIR } from '../../../../Utils/conts.js';
import DownloadGrid from '../components/DownloadGrid.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const Lease = () => {
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [totalRows, setTotalRows] = useState({});
    const [gridData, setGridData] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(ULDONAIRGRID, {})
                .then(function (res) {
                    const innerData = res.data.response_data.flights;
                    const innerDataCount = res.data.response_data.pagination;
                    setGridData(innerData);
                    setTotalRows({
                        pageSize: innerDataCount.page_size,
                        currPage: innerDataCount.current_page,
                        lastPage: innerDataCount.last_page,
                        totalUlds: innerDataCount.total
                    });
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        // Call the fetchData function to fetch data from the API
        if (isMounted.current) return;
        // fetchDataGrid();
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, [])
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridNestedSelect, setGridNestedSelect] = useState([]);
    const [selectedParentId, setSelectedParentId] = useState([]);
    const gridRef = useRef(null);

    const pageSize = totalRows.pageSize;
    const totalRowsCount = totalRows.totalUlds;
    const initCurrentPage = totalRows.currPage;
    useEffect(() => {

        if (gridRef.current) {
            // if (gridData) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            const source = {
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_count', type: 'string' },
                    { name: 'flight_or_truck', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'date' },
                    { name: 'flight_reg_number', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'origin_handler', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'destination_handler', type: 'string' },
                    { name: 'airline_name', type: 'string' },

                ],
                // localdata: gridData,
                // totalrecords: totalRowsCount,
                // addrow: function (rowid, rowdata, position, commit) {
                //     // Customize the row ID assignment to start from 0
                //     rowdata.uid = rowid;
                //     commit(true);
                // }
                url: `${process.env.REACT_APP_RFS_URL}handler-uld/list?tab=lease&type=A`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    window.$(gridRef.current).jqxGrid('clearselection');
                    setGridSelect([]);

                    if (allfilters.length > 0) {
                        console.log("Filter Applied");
                        setFilterApplied(true);
                    } else {
                        console.log("Filter Cleared");
                        setFilterApplied(false);
                    }
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata);
            // let columns;
            // if (activeTab === 'Flight') {
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
                    },
                    width: '5%', filterable: false,
                },
                {
                    text: 'Flight/Truck', filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Flight', value: 'F' },
                        { label: 'Truck', value: 'T' },

                    ], datafield: 'flight_or_truck', width: '7%', cellclassname: '',
                },
                { text: 'Flight Number', filtertype: 'textbox', datafield: 'flight_number', width: '8%', cellclassname: '', },
                { text: 'Flight date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', datafield: 'flight_date', width: '10%', cellclassname: '', },
                { text: 'Flight Reg. Number', filtertype: 'textbox', datafield: 'flight_reg_number', width: '10%', cellclassname: '', },
                { text: "Totals ULD's", filtertype: 'textbox', datafield: 'uld_count', width: '7%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
                { text: 'Origin Handler Name', filtertype: 'textbox', datafield: 'origin_handler', width: '12%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '6%', cellclassname: '', },
                { text: 'Destination Handler Name', filtertype: 'textbox', datafield: 'destination_handler', width: '12%', cellclassname: '', },
                { text: 'Airline Name', filtertype: 'textbox', datafield: 'airline_name', width: '14%', cellclassname: '', },
            ];
            // } else if (activeTab === 'ULD') {
            //     columns = [
            //         {
            //             text: 'Actions',
            //             cellsrenderer: function () {
            //                 return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /></div>';
            //             },
            //             width: '5%'
            //         },
            //         { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '11%', cellclassname: '', },
            //         { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '10%', cellclassname: '', },
            //         { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '10%', cellclassname: '', },
            //         { text: 'Condition Code', filtertype: 'textbox', datafield: 'condition_code', width: '10%', cellclassname: '', },
            //         { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '10%', cellclassname: '', },
            //         { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
            //         { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '8%', cellclassname: '', },
            //         { text: 'SCM', filtertype: 'textbox', datafield: 'scm', width: '6%', cellclassname: '', },
            //         { text: 'SCM Date', filtertype: 'textbox', datafield: 'scm_date', width: '6%', cellclassname: '', },
            //         { text: 'Asset Type', filtertype: 'textbox', datafield: 'asset_type', width: '6%', cellclassname: '', },
            //         { text: 'Handler Name', filtertype: 'textbox', datafield: 'handler_name', width: '6%', cellclassname: '', },
            //         { text: 'Repair Name', filtertype: 'textbox', datafield: 'repair_name', width: '6%', cellclassname: '', },
            //         { text: 'Repair Station', filtertype: 'textbox', datafield: 'repair_station', width: '6%', cellclassname: '', },
            //     ];
            // }

            // Nested ULD Start
            const nestedColumns = [
                { text: 'ULD Number', datafield: 'uld_number', width: '8%' },
                { text: 'Type Code', datafield: 'type_code', width: '8%' },
                { text: 'Serial Number', datafield: 'serial_number', width: '8%' },
                { text: 'Owner Code', datafield: 'owner_code', width: '8%' },
                { text: 'Condition Code', datafield: 'condition', width: '8%' },
                { text: 'Content Code', datafield: 'content', width: '8%' },
                { text: 'Final Dest.', datafield: 'final_dest', width: '8%' },

                {
                    text: 'ULD Asset',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.register === 'Y') {
                            // Return HTML with class 'inactive' for 'i' status
                            return '<div class="jqx-grid-cell-left-align set_dock register_green"> Registered </div>';
                        } else {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align set_dock non_register">  Non-registered </div>';
                        }
                    },
                    datafield: 'register', width: '10%'
                },
                {
                    text: 'Asset Type',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.asset_type === 'Y') {
                            // Return HTML with class 'inactive' for 'i' status
                            return '<div class="jqx-grid-cell-left-align set_dock  ">Owned</div>';
                        } else {
                            // Return HTML with class 'active' for 'a' status
                            return '<div class="jqx-grid-cell-left-align set_dock  ">Lease</div>';
                        }
                    },
                    datafield: 'asset_type', width: '8%'
                },
                { text: 'Airway Bill', datafield: 'awb_number', width: '8%' },
                // Add more columns as needed

            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                // console.log('Nested arrow clicked:', index, parentElement, gridElement, record);

                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;

                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    // Check if the click target is the nested arrow
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        // Handle nested arrow click here
                        // console.log('Nested arrow clicked:', record);
                        event.stopPropagation(); // Prevent event bubbling to the row details
                    }
                });
                console.log(dataAdapter);
                const id = record.uid.toString();
                const uldGrid = dataAdapter.loadedData.Rows[id].uld_level;

                const nestedSource = {
                    datatype: 'json',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'uld_number', type: 'string' },
                        { name: 'type_code', type: 'string' },
                        { name: 'serial_number', type: 'string' },
                        { name: 'owner_code', type: 'string' },
                        { name: 'condition', type: 'string' },
                        { name: 'condition_code', type: 'string' },
                        { name: 'content', type: 'string' },
                        { name: 'content_code', type: 'string' },
                        { name: 'final_dest', type: 'string' },
                        { name: 'register', type: 'string' },
                        { name: 'asset_type', type: 'string' },
                        { name: 'awb_number', type: 'string' },
                    ],
                    localdata: uldGrid,
                }

                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);

                const nestedGridOptions = {
                    width: '100%',
                    pageable: false,
                    sortable: false,
                    // pageSize: 15,
                    autoheight: false,
                    height: (10 * 45),
                    selectionmode: 'checkbox',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        // Manually set row IDs starting from 0
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i; // Use index as the new row ID
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

                window.$(nestedGridContainer).on('cellendedit', (event) => {
                    const args = event.args;
                    const rowData = args.row.bounddata;

                    if (args.datafield === 'select') {
                        setGridNestedSelect(prevState => {
                            if (args.value) {
                                return [...prevState, rowData];
                            } else {
                                return prevState.filter(row => row.id !== rowData.id);
                            }
                        });
                    }
                });

                // window.$(gridElement).on('rowselect', function (event) {
                //     const selectedRowIndex = event.args.rowindex;
                //     const rowDiv = window.$(this).closest('[role="row"]');
                //     const rowIndex = window.$(rowDiv).attr('row-id');
                //     // console.log("🚀 ~ rowDiv:", rowDiv)
                //     if (selectedRowIndex === index) {
                //         if (nestedGridContainer) {
                //             // Select all rows in the nested grid
                //             console.log("🚀 ~ window.$ ~ nestedGridContainer:", nestedGridContainer[index])
                //             const nestedRows = window.$(nestedGridContainer).jqxGrid('getrows');
                //             console.log("🚀 ~ window.$ ~ nestedRows:", nestedRows)
                //             for (let i = 0; i < nestedRows.length; i++) {
                //                 window.$(nestedGridContainer).jqxGrid('selectrow', i);
                //             }
                //         }
                //     }
                // });
                // window.$(gridElement).on('rowunselect', function (event) {
                //     const unselectedRowIndex = event.args.rowindex;
                //     if (unselectedRowIndex === index) {
                //         if (nestedGridContainer) {
                //             // Deselect all rows in the nested grid
                //             const nestedRows = window.$(nestedGridContainer).jqxGrid('getrows');
                //             for (let i = 0; i < nestedRows.length; i++) {
                //                 window.$(nestedGridContainer).jqxGrid('unselectrow', i);
                //             }
                //         }
                //     }
                // });
                window.$(nestedGridContainer).on('rowselect', (event) => {
                    console.log("🚀 ~ window.$ ~ event:00000000", event)
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        if ('uld_number' in selectedRow) {
                            const selectedRowId = selectedRow.uid;
                            if (!gridNestedSelect.some(row => row.uid === selectedRowId)) {
                                setGridNestedSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                                // setGridSelect(selectedRow);
                            }
                        }
                    } else {
                        const whgrid = event.target.id;
                        console.log("🚀 ~ window.$ ~ wh nested", whgrid)
                        if (whgrid.includes("nestedGrid")) {
                            if (event.args.rowindex.length > 0) {
                                const allIds = uldGrid; // gridData[id].uld_level;
                                setGridNestedSelect(allIds);
                            } else {
                                setGridNestedSelect([]);
                            }
                        }
                    }
                });

                window.$(nestedGridContainer).on('rowunselect', (event) => {
                    // console.log("🚀 ~ window.$ ~ event:1111", event.args.row)
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.uld_number;
                        console.log("🚀 ~ window.$ ~ unselectedRowId:", unselectedRowId)
                        setGridNestedSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                        // setGridNestedSelect([]);
                    }
                });

            };
            // Nested End

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',

                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (10 * 45),
                    rowdetailshidden: true,
                },

            };
            window.$(gridRef.current).on('rowselect', (event) => {
                console.log("🚀 ~ window.$ ~ event:00000001", event)
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    if ('flight_number' in selectedRow) {
                        const selectedRow = event.args.row;
                        const selectedRowId = selectedRow.uid;
                        if (!gridSelect.some(row => row.uid === selectedRowId)) {
                            setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                        }
                    }
                    // if (nestedGrids) {
                    //     // Select all rows in the nested grid
                    //     // console.log("🚀 ~ window.$ ~ nestedGridContainer:", nestedGridContainer[index])
                    //     const nestedRows = window.$(nestedGrids).jqxGrid('getrows');
                    //     console.log("🚀 ~ window.$ ~ nestedRows:", nestedRows)
                    //     for (let i = 0; i < nestedRows.length; i++) {
                    //         window.$(nestedGrids).jqxGrid('selectrow', i);
                    //     }
                    // }
                } else {
                    const whgrid = event.target.id;
                    setSelectedParentId(whgrid)
                    if (event.args.rowindex.length > 0) {
                        if (!whgrid.includes("nestedGrid")) {
                            const allIds = gridData;
                            setGridSelect(allIds);
                        }
                    } else {
                        if (!whgrid.includes("nestedGrid")) {
                            setGridSelect([]);

                        }
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.flight_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.flight_number !== unselectedRowId));
                }
            });

            window.$(gridRef.current).off('click');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
                keysToRemove.forEach(key => {
                    localStorage.removeItem(key);
                });
                // console.log("🚀 ~ event:01010", event)
                const rowDiv = window.$(this).closest('[role="row"]');
                // const cellDiv = this.id;
                // console.log("🚀 ~ cellDiv:", rowDiv)
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
                    if (rowData) {
                        // console.log('Row Data:', rowData);
                        onAirEdit(rowData.flight_number, rowData.flight_date, rowData.origin, rowData.destination);
                    } else {
                        console.error('No data found for the given row index.');
                    }
                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }

            });

            window.$(gridRef.current).jqxGrid(gridOptions);
            // window.$(gridRef.current).jqxGrid('gotopage', initCurrentPage - 1);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
        }
    }, [gridData, selectedRowData]);

    const onAirEdit = async (number, date, origin, destination) => {
        try {
            const res = await withRFSToken.post(EDITONAIR, { flight_number: number, flight_date: date, origin: origin, destination: destination })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    console.log("🚀 ~ innerData:", innerData)
                    // const [flight_code, flight_number] = innerData.Form.flight_number.split('-');

                    // const updatedForm = {
                    //     ...innerData.Form,
                    //     flight_code,
                    //     flight_number
                    // };
                    const storageData = {
                        "ULD": innerData.uld_level,  // ULD Details section
                        "Form": innerData.Form,  // Empty form section
                        "Edit": 'onAir'
                    };
                    localStorage.setItem('UCM Out', JSON.stringify(storageData));
                    localStorage.setItem('HULDtab', 'onair');
                    const fnPageUrl = '/ULDControl/ULDFunction';  // ${itemId} Change "/details/" to the actual path of your details page
                    // Navigate to the details page
                    window.location.href = fnPageUrl;
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };


    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };


    // +++++++++++++++++++++++++++++++++++++++++++++++++++++ file upload 

    const [html, setHtml] = useState('');

    function onChange(e) {
        setHtml(e.target.value);
    }

    // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider

    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFile('');
    };

    // ++++++++++++++++++++++++++++++++++++ Zoom Image
    const handleCloseClick = () => {
        setSelectedRowData(null);
    };

    const handleDropdownItemClick = async (action) => {
        // console.log("Event:", action);
        // event.preventDefault();
        // setShowConfirmation(true);
        const keysToRemove = ['Repair', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Request'];
        keysToRemove.forEach(key => {
            localStorage.removeItem(key);
        });


        const FltNum = gridSelect.map(item => item.flight_number);
        if (FltNum.length > 1) {
            toast.error('You Can process only one flight at a time')
        } else {
            const keysToRemove = ['Repair In', 'Repair Out', 'SCM', 'Lease Out', 'UCM Out', 'UCM In', 'LUC In', 'LUC Out', 'Transfer', 'Received'];
            keysToRemove.forEach(key => {
                localStorage.removeItem(key);
            });
            const uldIds = gridNestedSelect ? gridNestedSelect.map(item => item.uld_number) : '';

            try {
                // const res = await withRFSToken.post(EDITONAIR, { flight_number: gridSelect[0].flight_number, flight_date: gridSelect[0].flight_date })
                const flightNum = (gridSelect && gridSelect.length > 0) ? gridSelect[0].flight_number : '';
                const flightDate = (gridSelect && gridSelect.length > 0) ? gridSelect[0].flight_date : '';
                const flightReg = (gridSelect && gridSelect.length > 0) ? gridSelect[0].flight_reg_number : '';
                const origin = (gridSelect && gridSelect.length > 0) ? gridSelect[0].origin : '';
                const destination = (gridSelect && gridSelect.length > 0) ? gridSelect[0].destination : '';
                const res = await withRFSToken.post(EDITONAIR, { flight_number: flightNum, flight_date: flightDate, flight_reg_number: flightReg, ulds: uldIds, origin: origin, destination: destination })
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            const innerData = res.data.response_data;
                            console.log("🚀 ~ innerData:", innerData)
                            const storageData = {
                                "ULD": innerData.uld_level,  // ULD Details section
                                "Form": innerData.Form,  // Empty form section
                                // "Edit": 'onAir'
                            };
                            localStorage.setItem('UCM In', JSON.stringify(storageData));
                            localStorage.setItem('HULDtab', 'onair');
                            const fnPageUrl = '/ULDControl/ULDFunction';  // ${itemId} Change "/details/" to the actual path of your details page
                            // Navigate to the details page
                            window.location.href = fnPageUrl;
                        } else { toast.error(res.data.response_msg) }

                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // const fnPageUrl = `/ULDControl/ULDFunction?tab=onair&ids=${uldIds}&action=${action}`;  // ${itemId} Change "/details/" to the actual path of your details page
            // Navigate to the details page
            // window.location.href = fnPageUrl;
        }
    };
    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };

    const sendDload = { sec: 'uld', tab: 'lease' } 

    return (
        <>
            {downloadOpen && <DownloadGrid download_sec={sendDload} onClose={closeDownloadModal} />}
            <div className="mb-3 nestedtabs rounded minh">
                <div className='d-flex'>
                    {console.log('5578', gridSelect)}
                    {console.log('5579', gridNestedSelect)}
                    <Dropdown>
                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                            <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => handleDropdownItemClick('UCM In')}>UCM In</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
            <div className='ulddown'>
                <button onClick={showDownloadModal}><img src={Export} /> Download</button>
            </div>

            <div className="maindiv">
                <div className='trashdonload posr'>
                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                    {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                    {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="booking_tab">
                        <Tab eventKey="Flight" title={<span>Flight Level <Badge className='rabadge'>{gridData[activeTab].length}</Badge></span>} className='moveto'>
                            
                            <div ref={gridRefs.Flight} className='bookinggrid' ></div>
                        </Tab>
                        <Tab eventKey="ULD" title={<span>ULD Level <Badge className='rabadge'>{gridData[activeTab].length}</Badge></span>} className='moveto'>
                            <div ref={gridRefs.ULD} className='bookinggrid' ></div>
                        </Tab>

                    </Tabs> */}
                </div>
                {selectedRowData && (
                    <div className='SecondDiv'>
                        {/* {console.log('55', selectedRowData)} */}
                        <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                        <div className='girddtals_header'>
                            <h3>
                                {selectedRowData.bookingtruck_no} <span>{selectedRowData.status === 'A' ? <FontAwesomeIcon icon={faCircleCheck} /> : <FontAwesomeIcon icon={faCircle} />}</span> <span>{selectedRowData.status === 'A' ? 'Planned' : 'To be planned'}</span>
                            </h3>
                            <div className='d-flex actbtn'>

                                <Button variant="light" onClick={handleBrowseFiles} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                                        <FontAwesomeIcon icon={faBolt} /> Action
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleDropdownItemClick('UCM In')}>UCM In</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>

                            </div>

                        </div>
                        <div className='d-flex justify-content-between rabord'>
                            <div className='firstbrd'>
                                <p>Origin</p>
                                <span>{selectedRowData.origin}</span>
                            </div>
                            <div className='middlebrd'>
                                <p>{selectedRowData.date}</p>
                                <p><img src={Cargoplane} /></p>
                                <p>{selectedRowData.time}</p>
                            </div>
                            <div className='lastbrd'>
                                <p>destination</p>
                                <span>{selectedRowData.destination}</span>
                            </div>
                        </div>
                        <div>
                            <h3>Operational Trucks</h3>

                            {/* {selectedRowData && selectedRowData.operational_trucks.map((truck) => (
                               <div key={truck.truck_id} className='d-flex justify-content-between align-items-center opt_truck'>
                                   <div>
                                       <span>Truck No</span>
                                       <h4>{truck.truck_no}</h4>
                                   </div>
                                   <div className={truck.request_status == 'O' ? 'offer_reecv' : (truck.request_status == 'B' ? 'booked' : 'offer_rqst')}>
                                       <span>{truck.request_status == 'O' ? 'Offer Received' : (truck.request_status == 'B' ? 'Booked' : 'Requested')}</span>
                                   </div>
                                   <div>
                                       <Link>Details</Link>
                                   </div>
                               </div>
                           ))} */}
                        </div>

                        <ImageUpload attachable_type={"uld"} attachable_id={selectedRowData.bookingtruck_id} attachments={selectedRowData.attachments} />
                        <div>
                            <ActivityComments commentable_type={"uld"} commentable_id={selectedRowData.bookingtruck_id} allactivities={selectedRowData.activities} />
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Lease